import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper';

export default class DateTimeLabelViewModel extends ControlViewModel {

    /**
     * Der DateTime-String von .NET
     */
    public value: KnockoutObservable<string>;

    /**
     * Gibt an, ob das Datum angezeigt werden soll; kann auch null werden, wenn die Formatierung dem System überlassen wird
     */
    public showDate: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Uhrzeit angezeigt werden soll; kann auch null werden, wenn die Formatierung dem System überlassen wird
     */
    public showTime: KnockoutObservable<boolean>;

    /**
     * Das Date-Objekt
     */
    public date: KnockoutComputed<string>;

    /**
     * Das ViewModel für den DateAndTimePicker
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, '');
        this.showDate = this.observableOrDefault(params.showDate, null);
        this.showTime = this.observableOrDefault(params.showTime, null);
        this.date = this.defineComputed(() => {
            let value = this.value();
            let showDate = this.showDate();
            let showTime = this.showTime();

            if (DateHelper.isDotNetDatetimeString(value)) {
                let date = DateHelper.parseDotNetDateTimeString(value);
                return DateHelper.toString(date, showTime, showDate);
            } else {
                return '-';
            }
        });
    }
}

ComponentManager.setViewModel('DateTimeLabelViewModel', DateTimeLabelViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');